import type { SupportRequestStatus } from "../schemas/validators/support.lib";

export const MAX_ACTIVE_SUPPORT_AGENT_KEYS = 25;
export const SUPPORT_AGENT_KEY_SCAN_MAX = MAX_ACTIVE_SUPPORT_AGENT_KEYS + 1;

export const SUPPORT_CHAT_RECENT_ORDER_SCAN = 50;

export const MAX_GITHUB_LINKS = 25;
export const SUPPORT_GITHUB_LINK_SCAN_MAX = MAX_GITHUB_LINKS + 1;

export const MAX_SUPPORT_TICKETS_PER_GITHUB_ITEM = 100;
export const SUPPORT_GITHUB_ITEM_SCAN_MAX =
  MAX_SUPPORT_TICKETS_PER_GITHUB_ITEM + 1;

export const GITHUB_PULL_REQUEST_LINK_ACTIONS = [
  "opened",
  "reopened",
  "closed",
  "edited",
  "ready_for_review",
  "converted_to_draft",
] as const;

export const MAX_GITHUB_AUTO_LINK_SUPPRESSIONS_PER_TICKET = 100;
export const SUPPORT_GITHUB_SUPPRESSION_SCAN_MAX =
  MAX_GITHUB_AUTO_LINK_SUPPRESSIONS_PER_TICKET + 1;

export const MAX_TICKETS_PER_PROJECT_MOVE = 50;
export const MAX_RELATED_TICKETS = 20;
export const SUPPORT_TICKET_RELATIONS = ["part_of", "found_while"] as const;
export type SupportTicketRelation = (typeof SUPPORT_TICKET_RELATIONS)[number];
export const AGENT_RUN_CLAIM_SCAN_MAX = 25;
export const MAX_AGENT_TICKET_FIELD_UPDATES = 25;
export const AGENT_ATTACHMENT_IMAGE_MAX_BYTES = 3_750_000;
export const AGENT_ATTACHMENT_TEXT_MAX_BYTES = 200_000;
export const SUPPORT_PROJECT_SCAN_MAX = 500;
export const MAX_SUPPORT_PROJECT_FILES = 100;
export const MAX_SUPPORT_PROJECT_LINKS = 100;
export const MAX_SUPPORT_PROJECT_FILE_BYTES = 50 * 1024 * 1024;
export const SUPPORT_PROJECT_LINK_TITLE_MAX = 200;
export const SUPPORT_PROJECT_LINK_URL_MAX = 2048;
export const MAX_ISSUE_REPORT_SCREENSHOTS = 20;
export const AGENT_PROJECT_DOCUMENT_MAX_CHARS = 200_000;
export const AGENT_PROJECT_LIST_MAX = 50;
export const AGENT_PROJECT_TICKET_SCAN = 200;

export const AGENT_TICKET_PAGE_DEFAULT = 10;
export const AGENT_TICKET_PAGE_MAX = 50;
export const AGENT_TICKET_WORK_FILTER_SCAN_MAX = 500;

export const AGENT_TICKET_PAGE_LEGACY_MAX = 100;
export const AGENT_TICKET_MESSAGE_LEGACY_MAX = 100;
export const AGENT_TICKET_EXCERPT_MAX = 400;
export const AGENT_TICKET_MESSAGE_DEFAULT = 20;
export const AGENT_TICKET_MESSAGE_MAX = 100;

export const IDEMPOTENCY_KEY_MAX = 200;

export const MAX_MESSAGE_ATTACHMENTS = 6;
export const MAX_ATTACHMENT_NAME_LENGTH = 120;
export const MAX_USER_MESSAGE_LENGTH = 4000;
export const MAX_ADMIN_MESSAGE_LENGTH = 8000;
export const CONVERSATION_MESSAGE_SCAN_MAX = 500;

export const SUPPORT_DEPLOYMENT_PULL_PAGE = 20;
export const SUPPORT_DEPLOYMENT_PAGE_MAX = 250;
export const SUPPORT_DEPLOYMENT_WINDOW_MS = 90 * 24 * 60 * 60 * 1000;
export const SUPPORT_DEPLOYMENT_COMPARE_MAX = 15;
export const UPLOAD_CLAIM_WINDOW_MS = 24 * 60 * 60 * 1000;
export const TICKET_PURGE_BATCH = 200;

export const SUPPORT_OPEN_STATUSES = [
  "pending",
  "in_progress",
] as const satisfies ReadonlyArray<SupportRequestStatus>;
export const AI_BUG_REPORT_THREAD_PAGE_MAX = 10;
export const AI_BUG_REPORT_THREAD_MESSAGE_SCAN = 40;

export const SUPPORT_SUB_TICKET_SCAN_MAX = 100;
export const SUPPORT_OPEN_SUB_TICKETS_MAX = 25;
export const SUPPORT_SUB_TICKET_LIST_MAX = 25;

export const ORDER_ISSUE_REPORTING_PARTIES = ["buyer", "vendor"] as const;
export const ORDER_ISSUE_SCAN_MAX = 20;
export const ORDER_ISSUE_BACKFILL_SCAN_MAX = 500;

export const TEXTED_PHOTO_SCAN_MAX = 40;
export const TEXTED_PHOTO_LISTING_SCAN_MAX = 60;
export const TEXTED_PHOTO_FIRST_TYPE_SLUGS: ReadonlyArray<string> = [
  "pallets",
  "gaylord-boxes",
  "ibc-totes",
];
export const LISTING_FILE_SCAN_MAX = 12;
